export default __webpack_public_path__ + "static/media/CACHE-1920.5395f8c9.webp";